// 사업자 정보 페이지(전자상거래 표시의무). 푸터/심사에서 요구되는 사업자 식별 정보를 명시한다.

import LegalPageShell, { LegalSection } from "@/shared/LegalPageShell.tsx";
import { BUSINESS_INFO } from "@/shared/businessInfo.ts";

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex gap-2">
      <span className="w-28 shrink-0 text-ink-500">{label}</span>
      <span className="min-w-0 flex-1 text-ink-900">{value}</span>
    </div>
  );
}

// 사업자 정보 표시 페이지(전자상거래 표시의무 + 카드사 심사 요건).
export default function BusinessInfoPage() {
  return (
    <LegalPageShell title="사업자 정보">
      <LegalSection heading="사업자 정보">
        <Row label="상호" value={BUSINESS_INFO.name} />
        <Row label="대표자" value={BUSINESS_INFO.ceo} />
        <Row label="사업자등록번호" value={BUSINESS_INFO.bizRegNo} />
        {BUSINESS_INFO.ecommerceRegNo ? (
          <Row label="통신판매업 신고" value={BUSINESS_INFO.ecommerceRegNo} />
        ) : null}
        <Row label="사업장 소재지" value={BUSINESS_INFO.address} />
        <Row label="고객문의 전화" value={BUSINESS_INFO.tel} />
        <Row label="이메일" value={BUSINESS_INFO.email} />
      </LegalSection>
      <p className="text-xs text-ink-500">
        결제 및 카드 매입은 (주)포트원과 한국결제네트웍스(KPN)를 통해 처리됩니다. 본 정보는
        전자상거래 등에서의 소비자보호에 관한 법률에 따른 사업자 표시입니다.
      </p>
    </LegalPageShell>
  );
}
